// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:38
import * as SagaBase from '../../SagaBase';
import { CStamp } from '../../SagaSchema/CStamp';
import * as SagaSchema from '../../SagaSchema';
import { Guid, GuidTools } from '@models/guid';

export abstract class CStampProcedure_abstract extends CStamp {
  static $t: string = 'SagaSchema.CStampProcedure';
  $t: string = 'SagaSchema.CStampProcedure';

  public static GetMembers(): string[] {
    return [
      'SourceComponentUid',
      'VoiceChannel',
      'ServiceObjId',
      'ProcStepUid',
      'CommRequestUid',
      'ServiceName',
      'ResourceName',
      'Action',
      'Text',
      'ElementId',
      'SourceIdentifier',
      'StampOperation'
    ].concat(CStamp.GetMembers());
  }

  public GetMembers(): string[] {
    return CStampProcedure_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public SourceComponentUid: Guid = GuidTools.Empty;
  public VoiceChannel: string;
  public ServiceObjId: Guid = GuidTools.Empty;
  public ProcStepUid: Guid = GuidTools.Empty;
  public CommRequestUid: Guid = GuidTools.Empty;
  public ServiceName: string = '';
  public ResourceName: string;
  public Action: string;
  public Text: string = '';
  public ElementId: Guid = GuidTools.Empty;
  public SourceIdentifier: string;
  public StampOperation: SagaBase.Interfaces.StampProviderOperation = SagaBase.Interfaces.StampProviderOperation.Add;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
